import styled from 'styled-components';

export const HighlightsContainer = styled.div`
	display: flex;
	gap: 16px;
	width: 100%;
	justify-content: flex-start;
`;
